export function productOpen(product) {
  return product.isOpenForRegistration
    && (!product.autoCloseDate || new Date(product.autoCloseDate) > new Date());
}
